import { render, staticRenderFns } from "./RegisterEducationVisit.vue?vue&type=template&id=7a216e94&scoped=true"
import script from "./RegisterEducationVisit.vue?vue&type=script&lang=js"
export * from "./RegisterEducationVisit.vue?vue&type=script&lang=js"
import style0 from "./RegisterEducationVisit.vue?vue&type=style&index=0&id=7a216e94&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a216e94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a216e94')) {
      api.createRecord('7a216e94', component.options)
    } else {
      api.reload('7a216e94', component.options)
    }
    module.hot.accept("./RegisterEducationVisit.vue?vue&type=template&id=7a216e94&scoped=true", function () {
      api.rerender('7a216e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visitRegistry/components/RegisterEducationVisit.vue"
export default component.exports